module.exports = __webpack_public_path__ + "static/media/20E.48dbdc07.jpg";